export default __webpack_public_path__ + "static/media/blog-posts.d5354e11.png";